import React from "react";

type StepNumberBadgeProps = {
  stepNumber: number | string;
  isOpen: boolean;
  className?: string;
};

const StepNumberBadge: React.FC<StepNumberBadgeProps> = ({
  stepNumber,
  isOpen,
  className = "",
}) => {
  return (
    <span
      className={`flex items-center justify-center rounded-full
w-[24px] h-[24px] lg:w-[32px] lg:h-[32px]
${isOpen ? "bg-[#58F2A9]" : "bg-[#FFFFFF]"}
text-[#020202] font-medium text-[16px] lg:text-[20px] ${className}`}
    >
      {stepNumber}
    </span>
  );
};

export default StepNumberBadge;
